import { consoleKlickSignature } from '@klickmarketing/react-components'

export {
  WrapRootElement as wrapRootElement,
  WrapPageElement as wrapPageElement,
} from './provider-wrappers'

// Only print our signature to the console in prod
process.env.NODE_ENV === 'production' && consoleKlickSignature()
